import type { CanDeactivateFn } from '@angular/router';

/** A screen that can hold unsaved edits. */
export interface HasUnsavedChanges {
  /** Resolves true when it's fine to leave (nothing unsaved, or the user agreed to discard). */
  canLeave(): boolean | Promise<boolean>;
}

/**
 * Asks before leaving a screen with unsaved edits. On the Filters route it also runs on query-param
 * changes (runGuardsAndResolvers: 'paramsOrQueryParamsChange'), so switching filter, "+ New filter",
 * Cancel and the browser Back button are all covered — not just leaving the tab.
 */
export const unsavedChangesGuard: CanDeactivateFn<HasUnsavedChanges> = component => component?.canLeave?.() ?? true;
